import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Avatar, Text } from '../../atoms';
import { Button } from '../Button';
import { LetterAvatar } from '../LetterAvatar';

const StyledText = styled(Text)`
  white-space: nowrap;
`;

const NotificationItemContainer = styled.div`
  display: flex;
  flex-direction: ${({ small }) => (small ? 'row' : 'column')};
  align-items: ${({ small }) => (small ? 'center' : 'flex-start')};
  padding: 8px;
  row-gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 10px;
  margin-left: ${({ small }) => (small ? '10px' : '0')};
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;

const NotificationItem = ({
  initiator,
  picture = null,
  title,
  body = null,
  onAccept = null,
  onDecline = null,
  acceptLabel = null,
  declineLabel = null,
  small = false
}) => (
  <NotificationItemContainer small={small}>
    <InfoContainer>
      {picture ? (
        <Avatar width={34} height={34} src={picture} />
      ) : (
        <LetterAvatar name={initiator} size={34} />
      )}
      <StyledText $small>{title}</StyledText>
    </InfoContainer>
    {body}
    {onAccept && (
      <ButtonContainer small={small}>
        {acceptLabel && (
          <Button primary onClick={onAccept}>
            {acceptLabel}
          </Button>
        )}
        {declineLabel && (
          <Button critical onClick={onDecline}>
            {declineLabel}
          </Button>
        )}
      </ButtonContainer>
    )}
  </NotificationItemContainer>
);

NotificationItem.propTypes = {
  initiator: PropTypes.string.isRequired,
  picture: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  body: PropTypes.node,
  onAccept: PropTypes.func,
  onDecline: PropTypes.func,
  acceptLabel: PropTypes.string,
  declineLabel: PropTypes.string,
  small: PropTypes.bool
};

export { NotificationItem };
